import { API_URL } from "../utils/config";

export const USER_LOGIN = `${API_URL}/auth/login`;
export const USER_VERIFY = `${API_URL}/auth/verify`;
export const USER_VERIFY_2FA = `${API_URL}/auth/verify2fa`;

export const USERS_GET_ALL = `${API_URL}/users/getAll`;
export const USERS_GET_PAGING = `${API_URL}/users/getPaging`;
export const USERS_GET_BY_ID = `${API_URL}/users/getById`;
export const USER_CREATE = `${API_URL}/users/create`;
export const USER_UPDATE = `${API_URL}/users/update`;
export const USER_DELETE = `${API_URL}/users/delete`;
export const USER_PROFILE = `${API_URL}/users/profile`;

export const SETUP_2FA = `${API_URL}/users/setup2fa`;
export const ACTIVATE_2FA = `${API_URL}/users/activate2fa`;
export const DISABLE_2FA = `${API_URL}/users/disable2fa`;

export const ROLES_GET_ALL = `${API_URL}/roles/getAll`;
export const ROLES_GET_PAGING = `${API_URL}/roles/getPaging`;
export const ROLE_GET_BY_ID = `${API_URL}/roles/getById`;
export const ROLE_CREATE = `${API_URL}/roles/create`;
export const ROLE_UPDATE = `${API_URL}/roles/update`;
export const ROLE_DELETE = `${API_URL}/roles/delete`;

export const ACTIONS_GET_ALL = `${API_URL}/actions/getAll`;

export const ROLE_ACTION_CREATE = `${API_URL}/role-actions/create`;
export const ROLE_ACTION_DELETE = `${API_URL}/role-actions/delete`;

export const LINKS_GET_ALL = `${API_URL}/links/getAll`;
export const LINKS_GET_PAGING = `${API_URL}/links/getPaging`;
export const LINK_GET_BY_ID = `${API_URL}/links/getById`;
export const LINK_CREATE = `${API_URL}/links/create`;
export const LINK_UPDATE = `${API_URL}/links/update`;
export const LINK_DELETE = `${API_URL}/links/delete`;

export const LOGS_GET_PAGING = `${API_URL}/logs/getPaging`;
export const LOG_DELETE = `${API_URL}/logs/delete`;

export const ANALYTICS_GET = `${API_URL}/analytics/getAnalytics`;
export const OBSERVABILITY_EVENTS_GET = `${API_URL}/observability/events`;
export const OBSERVABILITY_ANALYTICS_GET = `${API_URL}/observability/analytics`;

export const WHITELIST_IPS_GET_PAGING = `${API_URL}/whitelist-ips/getPaging`;
export const WHITELIST_IP_CREATE = `${API_URL}/whitelist-ips/create`;
export const WHITELIST_IP_DELETE = `${API_URL}/whitelist-ips/delete`;